import { memo, useState, useEffect } from "react";
import styles from "./pdfRenderer.css";
import React from "react";

const PdfRenderer = ({ api }) => {
  const [pdfLink, setPdfLink] = useState("");
  console.log(pdfLink,"pdfLink")
  const onRowClick = (params) => {
    console.log(params, "params in pdf renderer");
    const pdfUrlPattern = /^https:\/\/files\.finkraft\.ai\/[a-f0-9]{32}$/;
    const findPdfUrl = (data) => {
      if (Array.isArray(data)) {
        for (let item of data) {
          const pdfUrl = findPdfUrl(item);
          if (pdfUrl) return pdfUrl;
        }
      } else if (typeof data === 'object' && data !== null) {
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            const pdfUrl = findPdfUrl(data[key]);
            if (pdfUrl) return pdfUrl;
          }
        }
      } else if (typeof data === 'string' && pdfUrlPattern.test(data)) {
  
        return data;
      }
      return null;
    };
    const pdfUrl = findPdfUrl(params.data);
    
    if (pdfUrl) {
      setPdfLink(pdfUrl);
    }
  };
  

 
  useEffect(() => {
    if (api) {
      api.addEventListener("rowClicked", onRowClick);
      return () => {
        api.removeEventListener("rowClicked", onRowClick);
      };
    }
  }, [api]);

  return (
    <div className={styles.pdfWrapper} style={{ width: 500, height: "100%" }}>
      <embed
        width="100%"
        height="600"
        src={pdfLink}
        type="application/pdf"
        style={{ height: "90%" }}
      ></embed>
    </div>
  );
};

export default memo(PdfRenderer);



